import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import { ReactComponent as Print } from "../../../../../assets/ViewLeave-images/print.svg";
// import { useNavigate } from "react-router-dom";
import CustomInput from "../../../../../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { getTaxLabel, getVisibleTaxSetting } from "../../../../../utils/payslipSettings";
import { payslipData } from "../../../../../constants/data";
import { ItemsValidates } from "../../../../../helper/Validation";
import Modal from "../../../../../components/Modal";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, } from "@mui/material";
import { formatDate } from "../../../../../utils/DateFormat";


const SalaryPayslips = ({ getLoanList, getLeave, leaveData, getDeductionList, deductionData, loanData, handleUpdate, loading, data, pensionData, getPensionList, getAllowanceList,
  getLevieList, allowanceData, levieData, getFringeList, fringeData, payslip, handleSalaryReport }) => {
  const [pensionOpen, setPensionOpen] = useState(false)
  const [allowanceOpen, setAllowanceOpen] = useState(false)
  const [levieOpen, setLevieOpen] = useState(false)
  const [fringeOpen, setFringeOpen] = useState(false)
  const [loanOpen, setLoanOpen] = useState(false)
  const [leaveOpen, setLeaveOpen] = useState(false)
  const [deductionOpen, setDeductionOpen] = useState(false)


  const handleData = (user) => {
    handleUpdate(user);
  }
  const handleLeave = () => {
    getLeave(data?.employee?._id);
    setLeaveOpen(true)
  }
  const handlePension = () => {
    getPensionList();
    setPensionOpen(true)

  };
  const handleLoan = () => {
    getLoanList();
    setLoanOpen(true)

  };

  const handleDeduction = () => {
    getDeductionList();
    setDeductionOpen(true)

  };

  const handleAllowance = () => {
    getAllowanceList();
    setAllowanceOpen(true)

  };
  const handleFringe = () => {
    getFringeList();
    setFringeOpen(true)

  };
  const handleLevie = () => {
    getLevieList();
    setLevieOpen(true)

  };



  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    payslipData,
    ItemsValidates,
    handleData,
  );
  const { employeeName, employeeNumber, salaryPHr, restraintTrade, reimbursiveTravel, pensionCompany, allowances, commission, taxable, totalTax,
    fringeBenefit, allDeductions, loanRepayment, uif, employerLevies, leave, grossIncome, totalDeductions, nettPay, payable, overtime
  } = state;

  // UIF/SDL rows follow the country-driven /payslip_settings list; labels come from the backend.
  const uifSetting = getVisibleTaxSetting(payslip, "UIF");
  const sdlSetting = getVisibleTaxSetting(payslip, "SDL");

  return (
    <>

      {/* {loading && <CircularIndeterminate />} */}

      <Box sx={style.mainContainer}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Payslip</Typography>
          {/* {permission?.accountSettings?.isEdit || role === "Admin" ?
            <Button variant="contained" color="success" sx={style.jobButton}>
            Create A New Job
            </Button>:null
          } */}
        </Box>

        <Button variant="contained" sx={style.printbtn} onClick={() => handleSalaryReport()}>
          <Box sx={style.downloadIcon} >
            <Print />
          </Box>
          Print
        </Button>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>

        <Grid container>
          <Grid item xs={12} lg={11.6} sx={style.gridbox}>
            <Box sx={style.inputSections}>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Employee Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.fullName}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Staff Id</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="employeeNumber"
                  error={employeeNumber?.error}
                  name="employeeNumber"
                  defaultValue={data?.employee?.stafId ?? 0}
                  readOnly={true}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeNumber" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Company Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.company?.companyName}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>

            </Box>

            <Box sx={style.inputSections}>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}>Payslip Number</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={true}
                  id="employeeName"
                  error={employeeName?.error}
                  name="employeeName"
                  defaultValue={data?.payslipNumber}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeName" />
              </Box>
              <Box sx={style.inputBoxes}>
                <Typography sx={style.inputText}> Payroll Frequency</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="employeeNumber"
                  error={employeeNumber?.error}
                  name="employeeNumber"
                  defaultValue={data?.frequency}
                  readOnly={true}

                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="employeeNumber" />
              </Box>
              <Box sx={style.inputBoxes}>
              </Box>


            </Box>

          </Grid>


        </Grid>

        <Grid container>
          <Grid item xs={12} lg={7.4}>
            <Grid container>


              <Grid item xs={12} lg={12} sx={style.gridbox}>
                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Salary</Typography></Box>
                </Box>
                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Salary</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="salaryPHr"
                      readOnly={true}

                      error={salaryPHr?.error}
                      name="salaryPHr"
                      defaultValue={data?.employee?.salaryInfo?.salary || 0}

                      onChange={handleChange}
                      onFocus={handleFocus}

                      autoComplete="salaryPHr" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Restraint Of Trade</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      readOnly={true}
                      id="restraintTrade"
                      error={restraintTrade?.error}
                      name="restraintTrade"
                      defaultValue={data?.employee?.salaryInfo?.restraintTrade || 0}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="restraintTrade" />
                  </Box>

                </Box>
                <Box sx={style.inputSection}>
                  {/* <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Travel Allowance</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="travelAllowance"
                      error={travelAllowance?.error}
                      readOnly={true}

                      name="travelAllowance"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.employee?.salaryInfo?.travelAll || 0}

                      autoComplete="travelAllowance" />
                  </Box> */}
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Reimbursive Travel (Business Km x Rate)</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="reimbursiveTravel"
                      error={reimbursiveTravel?.error}
                      readOnly={true}

                      type="Number"
                      name="reimbursiveTravel"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.totalRemb || 0}

                      autoComplete="reimbursiveTravel" />
                  </Box>

                </Box>


                {uifSetting && data?.uif != null && (
                  <>
                    <Box sx={style.greyLine}></Box>

                    <Box sx={style.lineTextGrid}>
                      <Box sx={style.permissionLine}></Box>
                      <Box><Typography sx={style.gridText}> {getTaxLabel(uifSetting)}</Typography></Box>
                    </Box>


                    <Box sx={style.inputSection}>

                      <Box sx={style.inputBox}>
                        <Typography sx={style.inputText}> {getTaxLabel(uifSetting)}</Typography>
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="uif"
                          error={uif?.error}
                          name="uif"
                          onChange={handleChange}
                          onFocus={handleFocus}
                          defaultValue={data?.uif || 0}
                          readOnly={true}

                          autoComplete="uif" />

                      </Box>

                    </Box>


                  </>
                )}
                {sdlSetting && data?.sdl != null && (
                  <>
                    <Box sx={style.greyLine}></Box>

                    <Box sx={style.lineTextGrid}>
                      <Box sx={style.permissionLine}></Box>
                      <Box><Typography sx={style.gridText}>{getTaxLabel(sdlSetting)}</Typography></Box>
                    </Box>


                    <Box sx={style.inputSection}>

                      <Box sx={style.inputBox}>
                        <Typography sx={style.inputText}>{getTaxLabel(sdlSetting)}</Typography>
                        <CustomInput
                          variant="outlined"
                          required
                          fullWidth
                          id="sdl"
                          error={uif?.error}
                          name="sdl"
                          onChange={handleChange}
                          onFocus={handleFocus}
                          defaultValue={data?.sdl || 0}
                          readOnly={true}
                          autoComplete="uif" />

                      </Box>

                    </Box>


                  </>
                )}

                <Box sx={style.greyLine}></Box>


                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Tax</Typography></Box>
                </Box>


                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Tax Rate</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="taxable"
                      error={taxable?.error}
                      name="taxable"
                      readOnly={true}
                      defaultValue={data?.taxRate || 0}

                      onChange={handleChange}
                      onFocus={handleFocus}

                      autoComplete="taxable" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Total Tax</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="totalTax"
                      error={totalTax?.error}
                      type="Number"
                      name="totalTax"
                      defaultValue={data?.totalTax || 0}
                      readOnly={true}

                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="totalTax" />
                  </Box>


                </Box>


                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Overtime</Typography></Box>
                </Box>

                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Overtime</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="overtime"
                      error={overtime?.error}
                      name="overtime"
                      readOnly={true}
                      defaultValue={data?.overTime || 0}

                      onChange={handleChange}
                      onFocus={handleFocus}

                      autoComplete="taxable" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Double Overtime</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="doubleOvertime"
                      error={overtime?.error}
                      type="Number"
                      name="doubleOvertime"
                      defaultValue={data?.doubleOverTime || 0}
                      readOnly={true}

                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="totalTax" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Extratime</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="doubleOvertime"
                      error={overtime?.error}
                      type="Number"
                      name="doubleOvertime"
                      defaultValue={data?.extraTime || 0}
                      readOnly={true}

                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="totalTax" />
                  </Box>
                  {/* <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Rate</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="rate"
                      error={rate?.error}
                      type="Number"
                      name="rate"
                      defaultValue={data?.rate || 0}
                      readOnly={true}
      
                      onChange={handleChange}
                      onFocus={handleFocus}
                      autoComplete="totalTax" />
                  </Box> */}


                </Box>

                <Box sx={style.greyLine}></Box>


                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Nett Pay </Typography></Box>
                </Box>

                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Nett Pay</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="nettPay"
                      error={nettPay?.error}
                      name="nettPay"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.netPay || 0}
                      readOnly={true}

                      autoComplete="nettPay" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Payable</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="payable"
                      error={payable?.error}
                      name="payable"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.payable || 0}
                      readOnly={true}

                      autoComplete="payable" />
                  </Box>

                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Absent</Typography></Box>
                </Box>
                <Box sx={style.inputSection}>

                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Absent</Typography>
                    {data?.isShowEmpty || data?.netPay !== 0 ? (
                      <CustomInput
                        variant="outlined"
                        required
                        fullWidth
                        id="nettPay"
                        error={nettPay?.error}
                        name="nettPay"
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={data?.attendanceDeduction}
                        readOnly={true}
                        autoComplete="nettPay" />
                    ) : (
                      <Typography sx={style.noDataText}>No data</Typography>
                    )}


                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>


                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Income</Typography></Box>
                </Box>


                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Gross Income</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="grossIncome"
                      error={grossIncome?.error}
                      name="grossIncome"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.grossInc || 0}
                      readOnly={true}

                      autoComplete="grossIncome" />
                  </Box>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>Total Deductions</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="totalDeductions"
                      error={totalDeductions?.error}
                      name="totalDeductions"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={data?.totalDeductions || 0}
                      readOnly={true}

                      autoComplete="totalDeductions" />
                  </Box>
                </Box>


              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} lg={4.4}>
            <Grid container>


              <Grid item xs={12} lg={12} sx={style.gridbox}>
                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Deductions</Typography></Box>
                </Box>
                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>All Deductions</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="allDeductions"
                      error={allDeductions?.error}
                      name="allDeductions"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      buttonText="View"
                      readOnly={true}
                      handleView={handleDeduction}

                      defaultValue={data?.totalDeductions || 0}
                      autoComplete="allDeductions" />

                  </Box>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Loan Repayment</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="loanRepayment"
                      error={loanRepayment?.error}
                      name="loanRepayment"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      buttonText="View"
                      readOnly={true}
                      handleView={handleLoan}

                      defaultValue={data?.totalLoan || 0}

                      autoComplete="loanRepayment" />
                  </Box>

                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Allowance</Typography></Box>
                </Box>



                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Allowances</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="allowances"
                      readOnly={true}

                      error={allowances?.error}
                      name="allowances"
                      onChange={handleChange}
                      buttonText="View"
                      onFocus={handleFocus}
                      defaultValue={data?.employee?.allowances?.amount || 0}
                      handleView={handleAllowance}

                      autoComplete="allowances" />
                  </Box>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Commission</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="commission"
                      error={commission?.error}
                      type="Number"
                      value={commission?.value}
                      name="commission"
                      onChange={handleChange}
                      readOnly={true}

                      onFocus={handleFocus}
                      defaultValue={data?.commission || 0}

                      autoComplete="commission" />
                  </Box>

                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Pension</Typography></Box>
                </Box>
                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Pension</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      readOnly={true}

                      id="pensionCompany"
                      error={pensionCompany?.error}
                      name="pensionCompany"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      buttonText="View"
                      defaultValue={data?.totalPension || 0}

                      handleView={handlePension}
                      autoComplete="pensionCompany" />
                  </Box>


                </Box>
                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Fringe Benefit </Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Fringe Benefit</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="fringeBenefit"
                      error={fringeBenefit?.error}
                      name="fringeBenefit"
                      onChange={handleChange}
                      buttonText="View"
                      handleView={handleFringe}

                      onFocus={handleFocus}
                      defaultValue={data?.totalFringe || 0}
                      readOnly={true}

                      autoComplete="fringeBenefit" />
                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Levies</Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Employer Levies</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="employerLevies"
                      error={employerLevies?.error}
                      name="employerLevies"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      buttonText="View"
                      readOnly={true}
                      handleView={handleLevie}

                      defaultValue={data?.totalLevie || 0}

                      autoComplete="employerLevies" />
                  </Box>


                </Box>

                <Box sx={style.greyLine}></Box>

                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box><Typography sx={style.gridText}>Leave</Typography></Box>
                </Box>


                <Box sx={style.inputSectionFull}>
                  <Box sx={style.inputBoxfullWidth}>
                    <Typography sx={style.inputText}>Leave</Typography>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="leave"
                      error={leave?.error}
                      name="leave"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      buttonText="View"
                      defaultValue={data?.totalLeave || 0}
                      readOnly={true}
                      handleView={handleLeave}

                      autoComplete="leave" />
                  </Box>
                </Box>


              </Grid>


            </Grid>
          </Grid>


        </Grid>

        {/* <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <LoadingButton loading={loading} variant="contained" type="submit" color="success" sx={style.jobButtons} >
              Save
            </LoadingButton>
          </Box>
          <Box sx={style.createJob}>
            <Button variant="contained" sx={style.cancelButtons}>
              Cancel
            </Button>
          </Box>

        </Box> */}
      </form>

      <Modal open={pensionOpen} setOpen={setPensionOpen} title={"Pensions"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Pension Type</TableCell>
                  <TableCell sx={style.TableHead}>Employer RateValue</TableCell>
                  <TableCell sx={style.TableHead}>Employee RateValue</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {pensionData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (


                  pensionData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employeeCont?.rateValue}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.employerCont?.rateValue}</TableCell>





                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={allowanceOpen} setOpen={setAllowanceOpen} title={"Allowance"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {allowanceData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (


                  allowanceData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={levieOpen} setOpen={setLevieOpen} title={"Levie"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>



                </TableRow>
              </TableHead>
              <TableBody>
                {levieData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (



                  levieData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={fringeOpen} setOpen={setFringeOpen} title={"Fringe"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>



                </TableRow>

              </TableHead>
              <TableBody>
                {fringeData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  fringeData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.amount}</TableCell>




                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={loanOpen} setOpen={setLoanOpen} title={"Loan Repayment"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Loan Amount</TableCell>
                  <TableCell sx={style.TableHead}>Repayment Amount</TableCell>
                  <TableCell sx={style.TableHead}>Pay Amount</TableCell>




                </TableRow>

              </TableHead>
              <TableBody>
                {loanData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  loanData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.loanAmt}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.repayAmt}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.payAmount}</TableCell>





                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>
      <Modal open={deductionOpen} setOpen={setDeductionOpen} title={"All Deductions"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Type</TableCell>
                  <TableCell sx={style.TableHead}>Amount</TableCell>




                </TableRow>

              </TableHead>
              <TableBody>
                {deductionData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  deductionData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.type}</TableCell>
                      <TableCell sx={style.tabledata}>{item?.rateValue}</TableCell>






                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>

      <Modal open={leaveOpen} setOpen={setLeaveOpen} title={"Leave"} loading={loading}>
        <Box>

          <TableContainer sx={style.table}>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell sx={style.TableHead}>Leave Type</TableCell>
                  <TableCell sx={style.TableHead}>Leave From</TableCell>
                  <TableCell sx={style.TableHead}>Leave To</TableCell>




                </TableRow>
              </TableHead>
              <TableBody>
                {leaveData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (

                  leaveData?.map((item, index) => (

                    <TableRow key={index}>

                      <TableCell sx={style.tabledata}>{item?.leaveType}</TableCell>
                      <TableCell sx={style.tabledata}>{formatDate(item?.leaveFrom)}</TableCell>
                      <TableCell sx={style.tabledata}>{formatDate(item?.leaveTo)}</TableCell>





                    </TableRow>


                  )))}

              </TableBody>

            </Table>


          </TableContainer>


        </Box>



      </Modal>

    </>
  )
}
export default SalaryPayslips;

